(() => {
  const SEL = '.scroll-split';
  const REVEALED = 'is-split-revealed';
  const WORD = 'split-word';
  const MAX_DELAY_INDEX = 16;

  const reduced = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const split = (el) => {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    let i = 0;
    const walk = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        if (!node.textContent.trim()) return;
        const frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach((tok) => {
          if (!tok) return;
          if (/^\s+$/.test(tok)) {
            frag.appendChild(document.createTextNode(tok));
          } else {
            const span = document.createElement('span');
            span.className = WORD;
            span.setAttribute('aria-hidden', 'false');
            span.style.setProperty('--word-index', Math.min(i++, MAX_DELAY_INDEX));
            span.textContent = tok;
            frag.appendChild(span);
          }
        });
        node.replaceWith(frag);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        Array.from(node.childNodes).forEach(walk);
      }
    };
    Array.from(el.childNodes).forEach(walk);
  };

  const reveal = (el) => el.classList.add(REVEALED);

  const init = (root) => {
    const scope = root || document;
    const els = scope.querySelectorAll(SEL);
    if (!els.length) return;

    if (reduced) {
      els.forEach((el) => { split(el); reveal(el); });
      return;
    }

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    els.forEach((el) => { split(el); obs.observe(el); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  }
})();
